import { Pipe, PipeTransform } from '@angular/core';
import { formatDate } from '@angular/common';
import { BehaviorSubject } from 'rxjs';

@Pipe({
  name: 'durationServer'
})
export class DurationServerPipe implements PipeTransform {

  transform(value: any, ...args: any[]): any {
      return this.getDiff(args[0],value);
  }

  getDiff(type:string,date:string){
    var commentdate:any;
      if(type === 'int'){
        commentdate = parseInt(date);
      }else{
        commentdate = new Date(`${date} UTC`).getTime();
        if(commentdate.toString() == "NaN"){
          commentdate = new Date(`${date}`).getTime();
        }
      }
      var today:any = new Date().getTime();
      let diffMins = this.minutesDiff(commentdate,today);
      let diffHrs = this.hoursDiff(commentdate,today);
      let diffDays = this.daysDiff(commentdate,today);
      let diffweek = this.weeksDiff(commentdate,today);
      let diffmonth  = this.monthsDiff(commentdate,today);
      let diffyear = this.yearsDiff(commentdate,today);

      if(type === 'hours' && diffHrs >= 24){
        return formatDate(`${date} UTC`,'yyyy-MM-dd hh:mm:ss a','en_US')
        //new Date(`${value}`).toUTCString().replace('GMT','');
      }
      if(diffyear > 0){
        return `${diffyear} year${diffyear > 1 ?'s ago':' ago'} `;
      }else if(diffmonth > 0){
        return `${diffmonth} month${diffmonth > 1 ?'s ago':' ago'} `;
      }else if(diffweek > 0){
        return `${diffweek} week${diffweek > 1 ?'s ago':' ago'} `;
      }else
      if(diffDays > 0){
        return `${diffDays} day${diffDays > 1 ?'s ago':' ago'} `;
      }else if(diffHrs > 0){
        return `${diffHrs} hour${diffHrs > 1 ?'s ago':' ago'} `;
      }else if(diffMins > 0){
        return `${diffMins} minute${diffMins > 1 ?'s ago':' ago'} `;
      }else{
          return "Just Now";
      }
  }
  secondsDiff(d1:number, d2:number) {
    let millisecondDiff = d2 - d1;
    let secDiff = Math.floor( ( d2 - d1) / 1000 );
    return secDiff;
 }

  minutesDiff(d1:number, d2:number) {
    let seconds = this.secondsDiff(d1, d2);
    let minutesDiff = Math.floor( seconds / 60 );
    return minutesDiff;
  }

  hoursDiff(d1:number, d2:number) {
    let minutes = this.minutesDiff(d1, d2);
    let hoursDiff = Math.floor( minutes / 60 );
    return hoursDiff;
  }

  daysDiff(d1:number, d2:number) {
    let hours = this.hoursDiff(d1, d2);
    let daysDiff = Math.floor( hours / 24 );
    return daysDiff;
 }

  weeksDiff(d1:number, d2:number) {
    let days = this.daysDiff(d1, d2);
    let weeksDiff = Math.floor( days/ 7 );
    return weeksDiff;
  }

  monthsDiff(d1:number, d2:number) {
    let week = this.weeksDiff(d1, d2);
    let monthDiff = Math.floor( week / 4 );
    return monthDiff;
  }

  yearsDiff(d1:number, d2:number) {
    let months = this.monthsDiff(d1, d2);
    let yearDiff = Math.floor( months/ 12 );
    return yearDiff;
  }

}
